import React from 'react';
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { selectFont } from '../../store/DynamicStyle/font_selectors';
import profileImage from '../../images/askwellie.png';

const ChatSidebar: React.FC = () => {
  const font = useSelector(selectFont);
  const location = useLocation();
  const path = location.pathname

  return (
    <div className='chat-left_sidebar'>
      <div className='profile-icons'>
        <Link to='/' className='chat-link'><img src={profileImage} alt='Profile' /></Link>
      </div>
      <div style={{ fontSize: font[0]?.sidebar_size }} className='chat-menu'>
        <ul className='chat-menu-wrapper'>
          <li className='chat-menu-list'><Link to='/about' className={path === "/about" ? "chat-link active" : "chat-link"}>About AskWellie</Link></li>
          <li className='chat-menu-list'><Link to='/services' className={path === "/services" ? "chat-link active" : "chat-link"}>Our Services</Link></li>
          <li className='chat-menu-list'><Link to='/accessibility' className={path === "/accessibility" ? "chat-link active" : "chat-link"}>Accessibility</Link></li>
          <li className='chat-menu-list'><Link to='/health-safety' className={path === "/health-safety" ? "chat-link active" : "chat-link"}>Health & Safety</Link></li>
          <li className='chat-menu-list'><Link to='/feedback-complaints' className={path === "/feedback-complaints" ? "chat-link active" : "chat-link"}>Feedback & Complaints</Link></li>
          <li className='chat-menu-list'><Link to='/privacy-data-protection' className={path === "/privacy-data-protection" ? "chat-link active" : "chat-link"}>Privacy & Data Protection</Link></li>
          <li className='chat-menu-list'><Link to='/news-updates' className={path === "/news-updates" ? "chat-link active" : "chat-link"}>News & Updates</Link></li>
          <li className='chat-menu-list'><Link to='/contact-us' className={path === "/contact-us" ? "chat-link active" : "chat-link"}>Contact Us</Link></li>
          <li className='chat-menu-list'><Link to='/faqs' className={path === "/faqs" ? "chat-link active" : "chat-link"}>FAQ’S</Link></li>
           
        </ul>
      </div>
    </div>
  );
};


export default ChatSidebar;
